import React from 'react'
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';

const Navbar = ({reloadNavbar}) => {

  function logout() {
    localStorage.removeItem("sessionKey");
    window.location.href = "/";
  }
  
  return (

    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container-fluid">
        <img src="https://i.ibb.co/hsBJj57/Alumni-Logo-removebg-preview.png" className="img-fluid" style={{ height: '60px' }} alt="" />
        <Link className="navbar-brand" to="/">NEC Alumni Association</Link>
        {console.log({reloadNavbar})}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse show" id="navbarNavAltMarkup">
          <ul className="navbar-nav me-auto ">
            <li className="nav-item active">
              <Link className="nav-link" to="/">Home</Link>
            </li>

          </ul>
          <div className='d-flex '>
            <form style={{ height: '100%', margin: 'auto' }}>
              <ul className="navbar-nav ">
                <li className="nav-item">
                  {
                    (localStorage.getItem('sessionKey') || reloadNavbar )
                      ? <>
                        <Link className="nav-link" to="/dashboard/users">Dashboard</Link>
                      </>
                      : <Link className="nav-link" to="/login">Login</Link>
                  }
                </li>
                <li>            {
                  ( localStorage.getItem('sessionKey') || reloadNavbar )
                    ? <div onClick={() => { logout(); }} style={{ cursor: 'pointer' }} className="nav-link" to="/logout">Logout</div>
                    : null
                }</li>
              </ul>
            </form>
          </div>

        </div>
      </div>
    </nav>


  );
}

export default Navbar;